<template>
  <div >

    <div class="text-h5 q-py-sm q-pl-sm">Other Liabilities and Expenses</div>
    <template v-if="fieldValue !== undefined">
      <q-form
          @submit="onSubmit"
          ref="form"
      >
      <div class="full-width">

      <div class="row ">
        <div class="col-12 col-md-6 q-px-sm q-py-sm ">
          <FieldSelect
              v-model="fieldValue.type"
              :field="{layout_injected_label: 'Other Liabilities and Expenses Type', label: 'Other Liabilities and Expenses Type', required: true, requiredText: null,
                options: options
                }"
              :hide_bottom_space="true"
          ></FieldSelect>
        </div>
        <div class="col-12 col-md-6 q-px-sm q-py-sm ">
          <FieldMoney
              v-model="fieldValue.monthly_payment"
              :field="{layout_injected_label: 'Monthly Payment', label: 'Monthly Payment', required: false, requiredText: null, options: {}}"
          ></FieldMoney>
        </div>

      </div>

      </div>
      </q-form>

    </template>


  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

import FieldSelect from "@/components/fields/FieldSelect";

import FieldMoney from "@/components/fields/FieldMoney";

import banks from "@/components/modules/assets/institutions";

import {mapActions} from "vuex";
export default {
  components: {

    FieldSelect,
    FieldMoney,

  },
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      banks: {},
      options: {
        'liability_Alimony': 'Alimony',
        'liability_Child_Support': 'Child Support',
        'liability_Separate_Maintenance': 'Separate Maintenance',
        'liability_Job_Related_Expenses': 'Job Related Expenses',
        'other_liabilities_expenses': 'Other Liabilities and Expenses',
      },
        real_estate_item: {
          address: "",
          unit: "",
          city: "",
          state: "",
          zip: "",
          country: "",
          property_type: "",
          status: "",
          intended_occupancy: "",
          market_value: "",
          monthly_gross_rent_income: "",
          current_mortgage_balance: "",
          monthly_rent_net_income: "",
          monthly_mortgage_payment: "",
          monthly_insurance: "",
          loans: [],
        },
        loan: {
          creditor_name: "",
          account_number: "",
          monthly_mortgage_payment: "",
          credit_limit: "",
          unpaid_balance: "",
          to_be_paid_off: false,
          type: ""
        },
        loan_types: {}
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      nextScreen: 'values/list/nextScreen'
    }),
    AddItem() {

    },
    onSubmit() {

    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    onAddressSelected(real_estate_item) {
      this.fieldValue.city = real_estate_item.city;
      this.fieldValue.state = real_estate_item.state;
      this.fieldValue.zip = real_estate_item.zipcode;
    },
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {
      console.log(banks);
      for(let i in banks) {
        this.banks[banks[i].name] = banks[i].name;
      }
  }
}
</script>
<style>
.field_no_bottom_line .q-field__control:before {
  border-bottom-color: transparent !IMPORTANT;
}
.field_no_bottom_line  .q-field__control:after {
  background: none !important;
}
.field_no_bottom_line .q-field__control {
  display: none;
}
.pac-container {
  z-index: 1000000;
}
</style>
